import { render, staticRenderFns } from "./ExamWrongExercise.vue?vue&type=template&id=2b0826b7&"
import script from "./ExamWrongExercise.vue?vue&type=script&lang=js&"
export * from "./ExamWrongExercise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/views/ExamWrongExercise.vue"
export default component.exports